import { render, staticRenderFns } from "./PopupPhone.vue?vue&type=template&id=92413dbc&scoped=true&"
import script from "./PopupPhone.vue?vue&type=script&lang=js&"
export * from "./PopupPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92413dbc",
  null
  
)

export default component.exports